module.exports = __webpack_public_path__ + "img/0-20.117d2675.jpg";